<section class="npg-dialog" role="dialog" aria-modal="true" aria-label="Guía para reactivar notificaciones">
  <header class="npg-dialog__header">
    <span class="npg-dialog__step-pill">Guía rápida</span>
    <h3 class="npg-dialog__title">Reactivar notificaciones</h3>
    <button type="button" class="npg-dialog__close" (click)="close()" aria-label="Cerrar guía">
      <i class="fas fa-times"></i>
    </button>
  </header>

  <div class="npg-dialog__body" aria-live="polite">

    <ng-container *ngIf="!isSafari">
      <div class="npg-guide">
        <article class="npg-guide-item">
          <span class="npg-guide-item__number">1</span>
          <div class="npg-guide-item__content">
            <div class="npg-mockup npg-mockup--urlbar">
              <svg viewBox="0 0 320 40" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <rect x="0" y="0" width="320" height="40" rx="20" fill="#f1f3f4" stroke="#dadce0" />
                <circle class="npg-mockup__halo" cx="20" cy="20" r="14" />
                <circle cx="20" cy="20" r="9" fill="#ffffff" stroke="#5f6368" stroke-width="1.5" />
                <g class="npg-site-icon npg-site-icon--sliders">
                  <path d="M15.5 17h9 M15.5 20h9 M15.5 23h9" stroke="#5f6368" stroke-width="1.4"
                    stroke-linecap="round" />
                  <circle cx="18" cy="17" r="1.3" fill="#5f6368" />
                  <circle cx="22.2" cy="20" r="1.3" fill="#5f6368" />
                  <circle cx="19.8" cy="23" r="1.3" fill="#5f6368" />
                </g>
                <g class="npg-site-icon npg-site-icon--lock">
                  <path d="M16 19h8v5h-8z M18 19v-2a2 2 0 0 1 4 0v2" stroke="#5f6368" fill="none"
                    stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <g class="npg-site-icon npg-site-icon--info">
                  <text x="18.3" y="24" fill="#5f6368" font-size="13" font-weight="700" font-family="sans-serif">i</text>
                </g>
                <g class="npg-site-icon npg-site-icon--shield">
                  <path d="M20 14.5l5 2v3.6c0 3-2 5.1-5 6.4-3-1.3-5-3.4-5-6.4v-3.6z"
                    stroke="#5f6368" fill="none" stroke-width="1.4" stroke-linejoin="round" />
                  <path d="M18 20l1.5 1.5 3-3" stroke="#5f6368" fill="none" stroke-width="1.3"
                    stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <text x="42" y="24" fill="#80868b" font-size="12" font-family="sans-serif">{{ currentHost }}</text>
              </svg>
            </div>

            <p class="npg-guide-item__copy">
              Abre la configuración del sitio desde el icono junto a la dirección web. Puede verse como
              controles, una "i" o un candado.
            </p>
          </div>
        </article>

        <article class="npg-guide-item">
          <span class="npg-guide-item__number">2</span>
          <div class="npg-guide-item__content">
            <div class="npg-mockup npg-mockup--dropdown">
              <svg viewBox="0 0 280 180" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <rect x="0" y="0" width="280" height="180" rx="8" fill="#ffffff" stroke="#dadce0" />
                <text x="14" y="24" fill="#202124" font-size="13" font-weight="600">{{ currentHost }}</text>
                <text x="14" y="46" fill="#5f6368" font-size="11">La conexión es segura</text>
                <line x1="0" y1="60" x2="280" y2="60" stroke="#dadce0" />
                <text x="14" y="84" fill="#202124" font-size="12" font-weight="600">Notificaciones</text>
                <g class="npg-mockup__allow">
                  <rect class="npg-mockup__allow-box" x="170" y="68" width="96" height="24" rx="6" />
                  <text class="npg-mockup__allow-text" x="184" y="84" font-size="11" font-weight="700">Permitir</text>
                </g>
                <text x="14" y="116" fill="#9aa0a6" font-size="12">Ubicación</text>
                <text x="14" y="142" fill="#9aa0a6" font-size="12">Cámara</text>
                <text x="14" y="168" fill="#9aa0a6" font-size="12">Micrófono</text>
              </svg>
            </div>

            <p class="npg-guide-item__copy">
              Busca <strong>Notificaciones</strong> y selecciona <strong>Permitir</strong>.
            </p>
          </div>
        </article>
      </div>
    </ng-container>

    <ng-container *ngIf="isSafari">
      <div class="npg-guide">
        <article class="npg-guide-item">
          <span class="npg-guide-item__number">1</span>
          <div class="npg-guide-item__content">
            <div class="npg-mockup npg-mockup--safari">
              <div class="npg-safari-icon" aria-hidden="true">
                <i class="fas fa-cog"></i>
              </div>
              <div class="npg-safari-path">
                <strong>Safari</strong>
                <span>Configuración > Sitios > Notificaciones</span>
              </div>
            </div>

            <p class="npg-guide-item__copy">
              Abre <strong>Safari > Configuración</strong>, entra a <strong>Sitios</strong> y selecciona
              <strong>Notificaciones</strong>.
            </p>
          </div>
        </article>

        <article class="npg-guide-item">
          <span class="npg-guide-item__number">2</span>
          <div class="npg-guide-item__content">
            <div class="npg-mockup npg-mockup--safari-list">
              <div class="npg-safari-site">
                <span>{{ currentHost }}</span>
                <div class="npg-safari-select" aria-hidden="true">
                  <strong>Permitir</strong>
                  <i class="fas fa-chevron-down"></i>
                </div>
              </div>
            </div>

            <p class="npg-guide-item__copy">
              Busca <strong>{{ currentHost }}</strong> en la lista de sitios y cambia el permiso a
              <strong>Permitir</strong>.
            </p>
          </div>
        </article>
      </div>
    </ng-container>

    <div class="npg-step__hint" *ngIf="showDeniedHint" role="alert">
      <i class="fas fa-exclamation-circle" aria-hidden="true"></i>
      <span>Si sigue bloqueado, confirma que las notificaciones queden marcadas como "Permitir".</span>
    </div>

    <div class="npg-dialog__footer">
      <button type="button" class="npg-btn npg-btn--primary" (click)="close()">
        Entendido
      </button>
    </div>
  </div>
</section>
